import { Props_SnippetSpacer } from "./Spacer.props";

export const SnippetSpacer = (props: Props_SnippetSpacer) => {
    const { snippet } = props;
    const { mobileHeight, desktopHeight, backgroundColor } = snippet;

    const snippetClass = `snippet-spacer snippet-spacer--mobile-${mobileHeight?.value} snippet-spacer--desktop-${desktopHeight?.value} snippet-spacer--background-${backgroundColor?.value}`;

    return (
        <div
            className={snippetClass}
            role="presentation"
        ></div>
    );
};

export default SnippetSpacer;